<div class="host-guest-tag">
  <div class="guest-tag-container tag-list">
    <ng-container *ngFor="let tag of listOfTag">
      <div
        class="tag with-delete"
        *ngIf="tag.selected"
        [style.background]="tag.color">
        {{ tag.name }}
        <div class="delete" [style.background-color]="tag.color" (click)="tag.selected = false; onCheckedChange();"></div>
      </div>
    </ng-container>
    <div
      class="tag add"
      nz-dropdown
      nzTrigger="click"
      nzPlacement="bottomLeft"
      [(nzVisible)]="dropdownVisible"
      [nzBackdrop]="false"
      [nzDropdownMenu]="menu">+{{ "order.add_tag" | translate }}</div>
  </div>

  <nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="modal-dropdown-guest-tag-container">
      <div class="body">
        <div class="tag-list">
          <div
            class="tag"
            [style.background]="tag.color"
            *ngFor="let tag of listOfTag">
            <label
              nz-checkbox
              [(ngModel)]="tag.selected"
              (ngModelChange)="onCheckedChange()">{{ tag.name }}</label>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="tag-manager">
          <a routerLink="/app/settings/options" [queryParams]="{ index: 1  }">
            <i nz-icon [nzType]="'setting'" [nzTheme]="'fill'"></i>
            <span class="text">{{ 'order.manage_tag' | translate }}</span>
          </a>
        </div>
        <div class="btns">
          <button nz-button nzSize="small" nzType="primary" (click)="dropdownVisible = false;">{{ "word.close" | translate }}</button>
        </div>
      </div>
    </div>
  </nz-dropdown-menu>
</div>
